import React from 'react';

import type { ApplicationStatus } from '../../model/application';

type Props = {
  status: ApplicationStatus;
};

const statusText: Record<ApplicationStatus, string> = {
  WAITING_DOWN_PAYMENT: 'Down payment required',
  SUCCESS: 'Success',
};

export const ApplicationStatusUI = React.memo<Props>(({ status }) => {
  const isApplicationSuccessful = status === 'SUCCESS';

  return (
    <span
      className={`
        ${isApplicationSuccessful ? 'text-green-700' : 'text-base-primary'}
      `}
    >
      {statusText[status]}
    </span>
  );
});
ApplicationStatusUI.displayName = 'ApplicationStatusUI';
